import { Modal } from '@atoms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';

const SuccessModal: FC<{ email?: string; onClose: () => void; open: boolean }> = ({
  email,
  onClose,
  open,
}) => (
  <Modal title="" open={open} onClose={onClose}>
    <Box
      width="200px"
      margin="auto"
      display="flex"
      alignItems="center"
      flexDirection="column"
      pb="12px"
    >
      <CheckCircleIcon color="info" sx={{ fontSize: 83 }} />
      <Typography mt="16px" mb="48px" variant="body1" textAlign="center">
        Invite has been sent to
        <br />
        <b>{email}</b>
      </Typography>
      <Button color="info" variant="contained" onClick={onClose} fullWidth>
        Got it
      </Button>
    </Box>
  </Modal>
);

export default SuccessModal;
